import React from 'react';
import Highcharts from 'highcharts';

import { ChartContent } from '../../Chart';

const StackedBarView = ({
  chartRef,
  options,
  remountKey,
}: {
  chartRef: React.MutableRefObject<any>;
  options: Highcharts.Options;
  remountKey: string;
}) => {
  return (
    <ChartContent
      chartRef={chartRef}
      options={options}
      key={`chart-${remountKey}`}
    />
  );
};

export default StackedBarView;
